/**
 * This hook is used to render different types of draftjs entities as HTML.
 * It provides functions to render images, embedded links, mentions, and links.
 * It also provides a function to get the entity markup based on the entity type.
 */
export const useRenderer = () => {
    const alignToBootstrap = {
        left: "text-start",
        right: "text-end",
        center: "text-center",
    };

    /**
     * Render image entity
     * @param {object} entity - Entity of draftjs
     * @returns {string} - HTML string
     */
    const image = (entity) => {
        const { alignment, src, alt, height, width } = entity?.data || {};
        const hasAlignment = alignment && alignment.length;
        let wrapperStart = hasAlignment
                ? `<div class="${alignToBootstrap[alignment]}">`
                : "",
            wrapperEnd = hasAlignment ? "</div>" : "";

        return `${wrapperStart}<img src="${src}" alt="${alt}" height="${height}" width="${width}" onerror="this.onerror=null; this.src='/assets/error-image-generic.png';" />${wrapperEnd}`;
    };

    /**
     * Render embedded entity. This is used for iframe embeds.
     * @param {object} entity - Entity of draftjs
     * @returns {string} - HTML string
     */
    const embedded_link = (entity) => {
        const { alignment, src, height, width } = entity?.data || {};
        const hasAlignment = alignment && alignment.length;
        let wrapperStart = hasAlignment
                ? `<div class="${alignToBootstrap[alignment]}">`
                : "",
            wrapperEnd = hasAlignment ? "</div>" : "";

        return `${wrapperStart}<iframe src="${src}" height="${height}" width="${width}" allowFullScreen></iframe>${wrapperEnd}`;
    };

    /**
     * Render mention entity.
     * @param {object} entity - Entity of draftjs
     * @returns {string} - HTML string
     */
    const mention = (entity) => {
        const { url, value } = entity?.data || {};
        return `<a href="${url}" class="wysiwyg-mention" data-mention data-value="${value}">${value}</a>`;
    };

    /**
     * Render link entity.
     * @param {object} entity - Entity of draftjs
     * @returns {string} - HTML string
     */
    const link = (entity, text = "") => {
        const { targetOption = "_self", url } = entity?.data || {};
        return `<a href="${url}" target="${targetOption}">${text}</a>`;
    };

    /**
     * Get entity markup based on the entity type.
     * @param {object} entity - Entity of draftjs
     * @param {string} text - Text to be rendered
     * @returns {string} - HTML string
     */
    const getEntityMarkup = (entity, text) => {
        const { type } = entity;
        if (type) {
            try {
                const fn = eval(type.toLowerCase());
                if (typeof fn === "function") {
                    return fn(entity, text);
                }
            } catch (e) {
                return text;
            }
        } else {
            return text;
        }
    };

    return {
        alignToBootstrap,
        image,
        embedded_link,
        mention,
        link,
        getEntityMarkup,
    };
};
